import { connect } from 'react-redux';
import { AppState } from '../../../../types/store';
import {
  getProfileOwnerUser,
  getProfileOwnerStat,
  isCurrentUserProfileOwner,
} from '../../../selectors/users';
import { WATCHER_IDS_STREAM } from '../../../streams';
import {
  selectors as streamSelectors,
  withOffset,
} from '@wix/da-shared-react/pkg/Stream';
import { getUsersByIds } from '@wix/da-shared-react/pkg/redux/users/selectors';

export const watchedDeviantsContainerCreator = streamId =>
  connect(
    (state: AppState) => {
      const type = streamId === WATCHER_IDS_STREAM ? 'watchers' : 'watching';
      const totalCount = getProfileOwnerStat(state, type);
      const watchedDeviants = getUsersByIds(
        state,
        streamSelectors.getItems(state, streamId)
      );
      const hasMore = streamSelectors.hasMore(state, streamId);
      const isFetching = streamSelectors.isFetching(state, streamId);
      return {
        type,
        visitor: {
          isLoggedin: false,
        },
        profileOwnerUser: getProfileOwnerUser(state),
        deviants: watchedDeviants,
        hasMore,
        isFetching,
        totalCount,
        isOwner: isCurrentUserProfileOwner(state),
        isEmpty: !watchedDeviants || !watchedDeviants.length,
        canSeeAll: streamSelectors.getStreamParam(state, streamId, 'canSeeAll'),
      };
    },
    dispatch => ({
      fetchMore: () => dispatch(withOffset.actions.fetch(streamId)),
    })
  );
